import { useEffect, useState } from "react";
import ServicioComun from "../../../../servicios/Comun";

/**
 * @param {string} clasePersona - La clase de la persona. Valores permitidos:  "F": persona física, "J": persona jurídica, null: todos
 * @returns {JSX.Element} - El componente renderizado
 */
function TipoPersonaDropdown({
  id,
  name,
  value = "0",
  clasePersona = null | "F" | "J",
  onChange,
  permiteSeleccionarValorDefault = false,
}) {
  const [tiposPersona, setTiposPersona] = useState([]);

  useEffect(() => {
    let isMounted = true;

    async function CargarTiposPersona() {
      let tiposPersona = await ServicioComun.ObtengaTiposPersona();

      if (!isMounted) return;

      if (clasePersona) {
        tiposPersona = tiposPersona.filter((x) => x.clase === clasePersona);
      }

      setTiposPersona(tiposPersona);
    }

    CargarTiposPersona();

    // Clean-up:
    return () => {
      isMounted = false;
    };
  }, [clasePersona]);

  return (
    <select
      className="form-control"
      id={id}
      name={name}
      value={value}
      onChange={onChange}
    >
      <option value="0" disabled={!permiteSeleccionarValorDefault}>
        [Tipo Persona]
      </option>
      {tiposPersona.map((item) => (
        <option key={item.codigo} value={item.codigo}>
          {item.descripcionLarga}
        </option>
      ))}
    </select>
  );
}

export default TipoPersonaDropdown;
